import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_Quot_Supplys/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_Quot_Supplys/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_Quot_Supplys/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_Quot_Supplys/update',
    method: 'post',
    data
  });
}

export function Confirm(data) {
  return request({
    url: '/Tx_Quot_Supplys/Confirm',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_Quot_Supplys/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_Quot_Supplys/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_Quot_Supplys/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 撤回
export function Back(data) {
  return request({
    url: '/Tx_Quot_Supplys/Back',
    method: 'post',
    data: { paramStr: data }
  });
}
